export const HOME = {
  emergentLink: "home-emergent-link",
};

export const APP = {
  root: "andariegos-app",
  loading: "loading-screen",
  header: "site-header",
  hero: "hero-section",
  heroLogo: "hero-logo",
  heroCta: "hero-scroll-indicator",
  categoryNav: "category-nav",
  categoryNavItem: (id) => `category-nav-${id}`,
  categorySection: (id) => `category-section-${id}`,
  productCard: (id) => `product-${id}`,
  footer: "site-footer",
  footerLogo: "footer-logo",
  marquee: "editorial-marquee",
};
